import React from 'react'
import styles from './index.module.scss'

interface IErrorProps {
  type: string
  title?: string
  subTitle?: string
  children?: any
}

export function Placeholder({
  type = 'empty',
  title,
  subTitle,
  children,
}: IErrorProps) {
  return (
    <div className={styles.placeholderWrap}>
      <div className={[styles.iconWrap, styles[type]].join(' ')}></div>
      <p className={styles.title}>
        {title || (type === 'error' ? '网络请求失败' : '暂无数据')}
      </p>
      {subTitle && <p className={styles.subTitle}>{subTitle}</p>}
      {children}
    </div>
  )
}
